export default __webpack_public_path__ + "840dc4e5fd162efe2548df818592c18a.svg";